<template>
  <div>

    <div class="inputPanel" :class="{'inputPanel__error' : invalidFields.franking_contract}">
      <div class="inputPanel__col inputPanel__question">
        <label>Is this current solution still in a lease contract?</label>
        <div class="inputPanel__col inputPanel__info">
          <div class="infoIcon">
            i
          </div>
        </div>
      </div>
      <div class="inputPanel__col inputPanel__input">
        <ul class="toggleBtns toggleBtns--fullWidth">
          <li>
            <input type="radio" id="byes" name="underlease" v-model="franking_contract" value="yes"/>
            <label for="byes">yes</label>
          </li>
          <li>
            <input type="radio" id="bleaseexpired" name="underlease" v-model="franking_contract" value="no_lease_expired"/>
            <label for="bleaseexpired">no the lease has expired</label>
          </li>
          <li>
            <input type="radio" id="bnopurchased" name="underlease" v-model="franking_contract" value="no_purchased"/>
            <label for="bnopurchased">no its purchased</label>
          </li>
          <li>
            <input type="radio" id="bidontknow" name="underlease" v-model="franking_contract" value="dont_know"/>
            <label for="bidontknow">i don't know</label>
          </li>
        </ul>
      </div>
      <error-modal>
        If you are unsure whether the current equipment is leased or owned the best way to check is to review your latest invoice/s. Purchased equipment will typically be invoiced for service/maintenance annually only, whereas leased/rented equipment will be invoiced, monthly, quarterly or annually and will confirm the lease/rental costs seperately from the service costs.
        <br><br><b>Having issues confirming or don't have the time to review?</b><br>
        **We offer a service whereby on your consent we will gather all necessary information and detail on your behalf. <a href="https://themailingexpert.com/let-us-do-it-for-you/" target="_blank">Click here</a> to understand more and to request this free service.**
      </error-modal>
      <info-modal>
        If you are unsure whether the current equipment is leased or owned the best way to check is to review your latest invoice/s. Purchased equipment will typically be invoiced for service/maintenance annually only, whereas leased/rented equipment will be invoiced, monthly, quarterly or annually and will confirm the lease/rental costs seperately from the service costs.
        <br><br><b>Having issues confirming or don't have a time to review:</b><br>
        **We offer a service whereby on your consent we will gather all necessary information and detail on your behalf. <a href="https://themailingexpert.com/let-us-do-it-for-you/" target="_blank">Click here</a> to understand more and to request this free service.**
      </info-modal>
    </div>

    <div class="inputPanel" :class="{'inputPanel__error' : invalidFields.franking_indicia}">
      <div class="inputPanel__col inputPanel__question">
        <label>Which indicia does your franking machine currently print i.e. town circle frank or mail mark frank?</label>
        <div class="inputPanel__col inputPanel__info">
          <div class="infoIcon" data-tip="Info here">
            i
          </div>
        </div>
      </div>
      <div class="inputPanel__col inputPanel__input">
        <ul class="toggleBtns toggleBtns--fullWidth toggleBtns--withImg">
          <li>
            <input type="radio" id="towncircle" name="indicia" v-model="franking_indicia" value="town_circle"/>
            <label for="towncircle">
              <span>Town Circle</span>
              <img src="../../../../../../static/styles/mailkit/img/towncircle.png" alt=""/>
            </label>
          </li>
          <li>
            <input type="radio" id="mailmark" name="indicia" v-model="franking_indicia" value="mailmark"/>
            <label for="mailmark">
              <span>Mailmark</span>
              <img src="../../../../../../static/styles/mailkit/img/mailmark.png" alt=""/>
            </label>
          </li>
          <li>
          </li>
        </ul>
      </div>
      <error-modal>
        Its important we understand what franking indicia type you currently use, as this helps us to confirm your anticipated postage savings. If you are unsure the best way to check is to look at a print from your franking machine. If your machine was acquired prior to 2014 chances are it isn't MailMark. You can always <b>'Live Chat'</b>
        or <b>'<a href="https://themailingexpert.com/contact-us/" target="_blank">contact us</a>'</b> for guidance and we will quickly and easily help you determine this.
      </error-modal>
      <info-modal>
        Its important we understand what Franking indicia type you currently use, as this helps us to confirm your anticipated postage savings. If you are unsure the best way to check is to look at a print from your franking machine. If your machine was acquired prior to 2014 chances are it isn't MailMark. You can always <b>'Live Chat'</b>
        or <b>'<a href="https://themailingexpert.com/contact-us/" target="_blank">contact us</a>'</b> for guidance and we will quickly and easily help you determine this.
      </info-modal>
    </div>

    <div class="inputPanel" :class="{'inputPanel__error' : invalidFields.franking_postage_payment}">
      <div class="inputPanel__col inputPanel__question">
        <label>Do you currently pay for postage in advance or arrears?</label>
        <div class="inputPanel__col inputPanel__info">
          <div class="infoIcon" data-tip="Info here">
            i
          </div>
        </div>
      </div>
      <div class="inputPanel__col inputPanel__input">
        <ul class="toggleBtns toggleBtns--inline">
          <li>
            <input type="radio" id="advanced" name="payforpostage" v-model="franking_postage_payment" value="advanced"/>
            <label for="advanced">advance</label>
          </li>
          <li>
            <input type="radio" id="arrears" name="payforpostage" v-model="franking_postage_payment" value="arrears"/>
            <label for="arrears">arrears</label>
          </li>
        </ul>
      </div>
      <error-modal>
        <b>Payment in arrears:</b><br>

        This service is only available through Pitney Bowes and Quadient (Neopost) at this time.

        This service allows businesses to top up franking machines, pulling funds from an agreed credit limit. Rather than an invoice for every postage top up/refill a monthly statement covering all transactions during that monthly billing period is instead sent. This service typically carries higher recrediting fees but reduces the number of invoices to one consolidated monthly statement and means your business doesn't have funds tied up and sitting in a holding account.

        Pitney Bowes payment in arrears service is called Purchase Power.

        Quadient (Neopost) is called Neofunds.

        <br><br><b>Payment in advance</b><br>

        The payment in advance services are available from all manufacturers and require your business to prepay into a deposit/holding account. When your franking machine is refilled/topped up funds will be drawn down from your account.

        For each top up/refill transaction your business will be invoiced for each transaction, plus any associated reset/recrediting charges. On payment of this invoice your holding/deposit account is replenished to the agreed balance ensuring you have suitable funds available for when you next need to top up.
      </error-modal>
      <info-modal>
        <b>Payment in arrears:</b><br>

        This service is only available through Pitney Bowes and Quadient (Neopost) at this time.

        This service allows businesses to top up franking machines, pulling funds from an agreed credit limit. Rather than an invoice for every postage top up/refill a monthly statement covering all transactions during that monthly billing period is instead sent. This service typically carries higher recrediting fees but reduces the number of invoices to one consolidated monthly statement and means your business doesn't have funds tied up and sitting in a holding account.

        Pitney Bowes payment in arrears service is called Purchase Power.

        Quadient (Neopost) is called Neofunds.

        <br><br><b>Payment in advance</b><br>

        The payment in advance services are available from all manufacturers and require your business to prepay into a deposit/holding account. When your franking machine is refilled/topped up funds will be drawn down from your account.

        For each top up/refill transaction your business will be invoiced for each transaction, plus any associated reset/recrediting charges. On payment of this invoice your holding/deposit account is replenished to the agreed balance ensuring you have suitable funds available for when you next need to top up.
      </info-modal>
    </div>

    <div class="inputPanel" :class="{'inputPanel__error' : invalidFields.printer_model_id}">
      <div class="inputPanel__col inputPanel__question">
        <label>
          Choose your current machine manufacturer and model from the list provided?
        </label>
        <div class="inputPanel__col inputPanel__info">
          <div class="infoIcon" data-tip="Info here">
            i
          </div>
        </div>
        <label>
          Some 3rd party resellers rename machines, so if you are unsure please contact us for support or use the images provided to help you confirm your choice.
        </label>
      </div>
      <div class="inputPanel__col inputPanel__input inputPanel__input--groupFull inputPanel__input--selectaproduct">
        <select name="currentmanone" v-model="selectedManufacturer">
          <option disabled value="null">Please Select</option>
          <option v-for="manufacturer in manufacturers" :value="manufacturer.id" v-if="canSelectManufacturer(manufacturer.id)">{{ manufacturer.name }}</option>
        </select>
        <select name="currentmantwo" v-model="printer_model_id">
          <option disabled value="null">Please Select</option>
          <option v-for="printer in printers" :value="printer.id">{{ printer.model }}</option>
        </select>
        <div class="box box--image" v-if="printerImage" style="width: 100%;">
          <!--<img src="../../../../../../static/styles/mailkit/img/manufacturer.png" alt=""/>-->
          <img :src="printerImage" alt="" style="width:100%; height:auto;"/>
        </div>
      </div>
      <error-modal>
        If you are unsure of the model of your machine use the image selection to help you to confirm, or 'live chat', '<a href="tel:0330 124 1977">call</a>' or '<a href="mailto:customerservices@themailingexpert.com">email</a>' with us and we can help confirm what model you should be selecting. Some resellers rename models varying them from original manufacturer name but we can help demystify this for you.
      </error-modal>
      <info-modal>
        If you are unsure of the model of your machine use the image selection to help you to confirm, or 'Live chat', '<a href="tel:0330 124 1977">Call</a>' or '<a href="mailto:customerservices@themailingexpert.com">email</a>' with us and we can help confirm what model you should be selecting. Some resellers rename models varying them from original manufacturer name but we can help demystify this for you.
      </info-modal>
    </div>

    <!--3 == Quadient (Neopost)-->
    <div class="inputPanel" :class="{'inputPanel__error' : invalidFields.franking_quadient_plan}" v-if="selectedManufacturer === 3">
      <div class="inputPanel__col inputPanel__question">
        <label>What service cover do you currently have from Quadient (Neopost)?</label>
        <div class="inputPanel__col inputPanel__info">
          <div class="infoIcon" data-tip="Info here">
            i
          </div>
        </div>
      </div>
      <div class="inputPanel__col inputPanel__input">
        <ul class="toggleBtns toggleBtns--fullWidth">
          <li>
            <input type="radio" id="essentialcare" name="quadient" v-model="franking_quadient_plan" value="essential_care"/>
            <label for="essentialcare">Essential Care</label>
          </li>
          <li>
            <input type="radio" id="totalcare" name="quadient" v-model="franking_quadient_plan" value="total_care"/>
            <label for="totalcare">Total Care – Includes 6 Hour Response And Reduced Fee For Neofund Recrediting</label>
          </li>
          <li>
            <input type="radio" id="idontknowc" name="quadient" v-model="franking_quadient_plan" value="dont_know"/>
            <label for="idontknowc">i don't know</label>
          </li>
        </ul>
      </div>
      <error-modal>
        Quadient (Neopost) offers two main types of service cover, 'Essential Care' and 'TotalCare'. The main differences between them are that Essential care is an 8 hour response SLA with higher postage recredit charges in comparison to TotalCare which has a 6 hour response SLA with lower recrediting fees. If you are unsure of which service you have please select 'Essential Care' or 'I Don't Know' and we will base the quote and savings on the most conservative rate to ensure we over deliver on savings.
      </error-modal>
      <info-modal>
        Quadient (Neopost) offers two main types of service cover, 'Essential Care' and 'TotalCare'. The main differences between them are that Essential care is an 8 hour response SLA with higher postage recredit charges in comparison to TotalCare which has a 6 hour response SLA with lower recrediting fees. If you are unsure of which service you have please select 'Essential Care' or 'I Don't Know' and we will base the quote and savings on the most conservative rate to ensure we over deliver on savings.
      </info-modal>
    </div>

    <div class="inputPanel" :class="{'inputPanel__error' : invalidFields.franking_quote_type}">
      <div class="inputPanel__col inputPanel__question">
        <label>Please confirm your quote requirements:</label>
        <div class="inputPanel__col inputPanel__info">
          <div class="infoIcon" data-tip="Info here">
            i
          </div>
        </div>
      </div>
      <div class="inputPanel__col inputPanel__input">
        <ul class="toggleBtns toggleBtns--fullWidth">
          <li>
            <input type="radio" id="likeforlike" name="quoterequirements" v-model="franking_quote_type" value="like_for_like"/>
            <label for="likeforlike">I Just Require a Like For Like Quote</label>
          </li>
          <li>
            <input type="radio" id="futureusage" name="quoterequirements" v-model="franking_quote_type" value="current_future"/>
            <label for="futureusage">I Require a Quote Based On Our Current And Future Usage Requirements?</label>
          </li>
        </ul>
      </div>
      <error-modal>
        When opting for a like for like quote we provide options from all manufacturers which are the modern day like for like comparative machines to that of which you curently have in place.
        <br>
        When opting for a quote based on current and future usage requirements, we automatically provide suitable options based on this. This may mean we present lower or higher specification models to that of which is already in use.
      </error-modal>
      <info-modal>
        When opting for a like for like quote we provide options from all manufacturers which are the modern day like for like comparative machines to that of which you curently have in place.
        <br>
        When opting for a quote based on current and future usage requirements, we automatically provide suitable options based on this. This may mean we present lower or higher specification models to that of which is already in use.
      </info-modal>
    </div>

    <div class="inputPanel" :class="{'inputPanel__error' : invalidFields.postage_spend_custom}">
      <div class="inputPanel__col inputPanel__question">
        <label>Please enter your typical monthly postage spend. </label>
        <div class="inputPanel__col inputPanel__info">
          <div class="infoIcon" data-tip="Info here">
            i
          </div>
        </div>
      </div>
      <div class="inputPanel__col inputPanel__input inputPanel__input--groupFull inputPanel__input--selectaproduct">
        <input type="number" class="inputLarge" name="monthlypostage" id="monthlypostage" placeholder="Enter Value" v-model="postage_spend_custom" v-positive-numbers-only/>
      </div>
      <error-modal>
        Please confirm the typical amount that you would top up your franking machine each month, if you don't top up every month please simply take your annual spend and divide it by twelve.
      </error-modal>
      <info-modal>
        Please confirm the typical amount that you would top up your franking machine each month, if you don't top up every month please simply take your annual spend and divide it by twelve.
      </info-modal>
    </div>
  </div>
</template>
<script>
  import {mapState, mapMutations} from 'vuex'
  import InfoModal from '../../InfoModal.vue'
  import Error from '../../ErrorModal.vue'

  export default {
    components: {
      'error-modal': Error,
      'info-modal': InfoModal
    },

    created() {
      this.axios.all([
        this.axios.get('/manufacturers'),
      ])
        .then(this.axios.spread((manufacturers) => {
          this.manufacturers = manufacturers.data
        }));
      this.loadPrinters()
    },

    data() {
      return {
        manufacturers: [],
        printers: [],
      }
    },

    computed: {
      ...mapState('QuoteForm', ['step1', 'invalidFields']),
      selectedManufacturer: {
        get() {
          return this.step1.selectedManufacturer
        },
        set(value) {
          this.franking_quadient_plan = null
          this.franking_quote_type = null
          this.updateStep1({selectedManufacturer: value})
          this.loadPrinters()
//          this.printer_model_id = null
          this.postage_spend_per_month = null
        }
      },
      franking_contract: {
        get() {
          return this.step1.franking_contract
        },
        set(value) {
          this.updateStep1({franking_contract: value})
        }
      },
      franking_indicia: {
        get() {
          return this.step1.franking_indicia
        },
        set(value) {
          this.updateStep1({franking_indicia: value})
        }
      },
      franking_postage_payment: {
        get() {
          return this.step1.franking_postage_payment
        },
        set(value) {
//          this.selectedManufacturer = null
          this.updateStep1({
            franking_postage_payment: value,
//            printer_model_id: null,
          })
        }
      },
      printer_model_id: {
        get() {
          return this.step1.printer_model_id
        },
        set(value) {
          this.updateStep1({printer_model_id: value})
        }
      },
      franking_quadient_plan: {
        get() {
          return this.step1.franking_quadient_plan
        },
        set(value) {
          this.updateStep1({franking_quadient_plan: value})
        }
      },
      franking_quote_type: {
        get() {
          return this.step1.franking_quote_type
        },
        set(value) {
          this.updateStep1({franking_quote_type: value})
        }
      },
      postage_spend_per_month: {
        get() {
          return this.step1.postage_spend_per_month
        },
        set(value) {
          this.updateStep1({
            postage_spend_per_month: value,
            postage_spend_custom: null
          })
        },
      },
      postage_spend_custom: {
        get() {
          return this.step1.postage_spend_custom
        },
        set(value) {
          this.updateStep1({
            postage_spend_custom: value
          })
        }
      },

      printerImage() {
        if (this.printer_model_id) {
          for (let key in this.printers) {
            if (this.printers[key].id === this.printer_model_id && this.printers[key].image_url) {
              return '/static/styles/mailkit/img/printers/' + this.printers[key].image_url
            }
          }
        }
        return false
      }

    },

    methods: {
      ...mapMutations('QuoteForm', ['updateStep1']),
      loadPrinters() {
        if (this.selectedManufacturer) {
          this.axios.get('/printers', {params: {manufacturer_id: this.selectedManufacturer}}).then(response => {
            this.printers = response.data
          })
        }
      },
      canSelectManufacturer(id) {
        if (this.franking_postage_payment === null || this.franking_postage_payment === 'advanced') {
          return true
        }
        return this.franking_postage_payment === 'arrears' && (id === 2 || id === 3);
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Quotes/Form/Step-1/Conditionals/Form_UsesFrankingMachine.vue